import forEach from 'lodash/forEach';

type Photo = {
  url?: string;
};

type Floorplan = {
  largePhotos?: Array<Photo>;
};

type Listing = {
  largePhotos?: Array<Photo>;
  floorplans?: Array<Floorplan>;
};

type PhotoGridParams = {
  listing?: Listing;
  observer?: IntersectionObserver;
};

type PhotoGridItem = {
  src: string | undefined;
  intersectionObserver: IntersectionObserver | undefined;
  galleryidx: number;
};

const controller = {
  getPhotoGridPhotos: ({ listing = {}, observer }: PhotoGridParams) => {
    const { largePhotos = [], floorplans = [] } = listing;

    const photoGridArray: Array<PhotoGridItem> = [];
    const floorplanGridArray: Array<PhotoGridItem> = [];

    // Generate proper photo object for PhotoGrid library.
    forEach(largePhotos, (photo = {}, idx) => {
      const imgDetails = {
        src: photo.url,
        intersectionObserver: observer,
        galleryidx: idx, // must be lowercase
      };

      photoGridArray.push(imgDetails);
    });

    // indices need to continue from the previous photo grid
    // cannot use idx in forEach because some floorplans have multiple largePhotos
    let idx = largePhotos.length;

    forEach(floorplans, (fp = {}) => {
      const { largePhotos: largeFpPhotos = [] } = fp;
      forEach(largeFpPhotos, (photo = {}) => {
        const imgDetails = {
          src: photo.url,
          intersectionObserver: observer,
          galleryidx: idx,
        };

        idx += 1;

        floorplanGridArray.push(imgDetails);
      });
    });

    return { photoGridArray, floorplanGridArray };
  },
};

export default controller;
